import { VirtualProvisioningModalProvider } from '@perpay-web/fintech/components/composite/VirtualProvisioningModal/useVirtualProvisioningModalContext';
import { BiometricRegistrationFailedModalProvider } from '@perpay-web/fintech/hooks/useBiometricRegistrationFailedModalContext';
import { CardApplicationConfirmAddressModalProvider } from '@perpay-web/fintech/hooks/useCardApplicationConfirmAddressModalContext';
import { CardAutoPayMakePaymentModalProvider } from '@perpay-web/fintech/hooks/useCardAutoPayMakePaymentModalContext';
import { CardCancelAutoPayScheduleModalProvider } from '@perpay-web/fintech/hooks/useCardCancelAutoPayScheduleModalContext';
import { EmailMisspelledModalProvider } from '@perpay-web/fintech/hooks/useEmailMispelledModalContext';
import { NativeUpgradeNotificationModalProvider } from '@perpay-web/fintech/hooks/useNativeUpgradeNotificationModalContext';
import { OverpaymentDecisionModalProvider } from '@perpay-web/fintech/hooks/useOverpaymentDecisionModalContext';
import { PartnerOnboardingExistingUserModalProvider } from '@perpay-web/fintech/hooks/usePartnerOnboardingExistingUserModalContext';
import { PartnerOnboardingSignupIneligibleStateModalProvider } from '@perpay-web/fintech/hooks/usePartnerOnboardingSignupIneligibleStateModalContext';
import { SuccessMessagePopUpProvider } from '@perpay-web/fintech/hooks/useSuccessMessagePopUpContext';
import { UpdatePhoneNumberModalProvider } from '@perpay-web/fintech/hooks/useUpdatePhoneNumberModalContext';
import { UserVerificationHelpModalProvider } from '@perpay-web/fintech/hooks/useUserVerificationHelpModalContext';
import { UserVerificationModalProvider } from '@perpay-web/fintech/hooks/useUserVerificationModalContext';
import { createCombinedProvider } from '@perpay-web/utils/componentUtils';

const ModalProviders = createCombinedProvider(
    CardApplicationConfirmAddressModalProvider,
    CardAutoPayMakePaymentModalProvider,
    CardCancelAutoPayScheduleModalProvider,
    PartnerOnboardingSignupIneligibleStateModalProvider,
    PartnerOnboardingExistingUserModalProvider,
    EmailMisspelledModalProvider,
    NativeUpgradeNotificationModalProvider,
    BiometricRegistrationFailedModalProvider,
    SuccessMessagePopUpProvider,
    UserVerificationModalProvider,
    VirtualProvisioningModalProvider,
    OverpaymentDecisionModalProvider,
    UserVerificationHelpModalProvider,
    UpdatePhoneNumberModalProvider,
);

export default ModalProviders;
